import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M12 .5C18.351.5 23.5 5.649 23.5 12S18.351 23.5 12 23.5.5 18.351.5 12 5.649.5 12 .5"/> <path d="M12 .5C18.351.5 23.5 5.649 23.5 12S18.351 23.5 12 23.5.5 18.351.5 12 5.649.5 12 .5Z" stroke="#243E81"/> <path d="M18.144 11.5H5.856a.51.51 0 0 0-.523.5c0 .276.234.5.523.5h12.288a.51.51 0 0 0 .523-.5c0-.276-.234-.5-.523-.5" fill="#243E81"/>' }
  })
);